// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-tv-chart-container {
  display: block;
  height: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/tv-chart-container/tv-chart-container.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,YAAA;AACF","sourcesContent":[".app-tv-chart-container {\n  display: block;\n  height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
